'use client';

import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { useTranslations } from 'next-intl';
import { useContext, useState } from 'react';

import { Button, HeroIcon } from '@/components/atoms';
import { Sheet } from '@/components/molecules';
import { FavoritesContext } from '@/lib/contexts/favouriting';

import { AddToPlaylist } from './AddToPlaylist';
import { CreatePlaylistForm } from './CreatePlaylist';

export interface AddMenuProps {
  drawerOpen: boolean;
  drawerOpenAction: (open: boolean) => void;
  trackId: number;
}

export const AddMenu = ({
  drawerOpen,
  drawerOpenAction,
  trackId,
}: AddMenuProps) => {
  const t = useTranslations();
  const favoritesContext = useContext(FavoritesContext);
  const [isCreatingNewPlaylist, setIsCreatingNewPlaylist] = useState(false);
  if (!favoritesContext) {
    throw new Error('Addmenu must be wrapped in provider');
  }
  const {
    addTrackToUserPlaylist,
    userPlaylists,
    createUserPlaylistAndStore,
    fetchUserPlaylists,
  } = favoritesContext;
  const handleBackBtn = () => {
    setIsCreatingNewPlaylist(false);
  };
  return (
    <Sheet.Root
      isOpen={drawerOpen}
      onOpenChange={drawerOpenAction}
      aria-labelledby="test"
      className="flex flex-col w-full"
    >
      <Sheet.Header>
        <Sheet.Title>
          {isCreatingNewPlaylist ? (
            <Button variant={'ghost'} onClick={handleBackBtn}>
              <HeroIcon icon={ChevronLeftIcon} size="medium" />
              <div className="flex flex-col justify-center">
                {t('B2B_LIBRARY_SEE_ALL_BUTTON_BACK')}
              </div>
            </Button>
          ) : (
            ''
          )}
        </Sheet.Title>
        <Sheet.Description className="sr-only">
          {t('PLAYER_ACTIONS_1')}
        </Sheet.Description>
        <Sheet.Close />
      </Sheet.Header>
      <Sheet.Body className="flex flex-col items-center overflow-auto gap-2 w-full">
        {!isCreatingNewPlaylist ? (
          <AddToPlaylist
            trackId={trackId}
            userPlaylists={userPlaylists}
            addTrackToUserPlaylist={addTrackToUserPlaylist}
            onDone={() => drawerOpenAction(false)}
            onCreatePlaylistClick={() => setIsCreatingNewPlaylist(true)}
          />
        ) : (
          <CreatePlaylistForm
            trackId={trackId}
            createUserPlaylistAndStore={createUserPlaylistAndStore}
            addTrackToUserPlaylist={addTrackToUserPlaylist}
            fetchUserPlaylists={fetchUserPlaylists}
            onDone={() => drawerOpenAction(false)}
          />
        )}
      </Sheet.Body>
    </Sheet.Root>
  );
};
